/* eslint-disable */
import React, { useEffect, useState } from "react";
import RenderHome from "../home/RenderHome";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../service/axios/axios";

const TYPE_LABELS = {
  loan: "Loans",
  mart: "UPNMG Mart",
};

const TYPE_COLORS = {
  loan: { background: "#e3f2fd", color: "#0d47a1", border: "1px solid #90caf9" },
  mart: { background: "#f1f8e9", color: "#33691e", border: "1px solid #aed581" },
};

function MySettlementQuotation() {
  const [settlements, setSettlements] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const fetchSettlements = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get("/settlement/my-settlements");
      setSettlements(res.data || []);
    } catch (err) {
      toast.error("Failed to load settlement quotations.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSettlements();
  }, []);

  const handleDownloadPDF = async (id, memberName) => {
    setDownloading(id);
    try {
      const res = await axiosInstance.get(`/settlement/pdf/${id}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `settlement-quote-${memberName}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error("Failed to download PDF. Please try again.");
    } finally {
      setDownloading(null);
    }
  };

  const statusBadge = (status) => {
    const styles = {
      pending: {
        background: "#fff3e0",
        color: "#e65100",
        border: "1px solid #ffb74d",
      },
      processed: {
        background: "#e8f5e9",
        color: "#2e7d32",
        border: "1px solid #81c784",
      },
    };
    return (
      <span
        style={{
          ...styles[status],
          padding: "3px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 600,
          textTransform: "capitalize",
        }}
      >
        {status}
      </span>
    );
  };

  const typeBadge = (type) => {
    const style = TYPE_COLORS[type] || {
      background: "#f5f5f5",
      color: "#555",
      border: "1px solid #ddd",
    };
    return (
      <span
        style={{
          ...style,
          padding: "3px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 600,
        }}
      >
        {TYPE_LABELS[type] || type || "—"}
      </span>
    );
  };

  return (
    <RenderHome>
      <ToastContainer />
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "24px 16px" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{ background: "#2d6a4f", padding: "20px 28px", color: "#fff" }}
          >
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
              My Settlement Quotations
            </h2>
            <p style={{ margin: "6px 0 0", fontSize: 13, opacity: 0.85 }}>
              View and download your processed outright settlement quotes.
            </p>
          </div>

          <div style={{ padding: "24px 28px" }}>
            {isLoading ? (
              <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
                Loading...
              </div>
            ) : settlements.length === 0 ? (
              <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
                <p style={{ fontSize: 15 }}>No settlement quotations found.</p>
                <p style={{ fontSize: 13 }}>
                  Use the <strong>Request Settlement</strong> menu item to
                  submit a request.
                </p>
              </div>
            ) : isMobile ? (
              /* ── Mobile: card list ── */
              <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                {settlements.map((s) => (
                  <div
                    key={s._id}
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 10,
                      padding: "16px",
                      background: "#fafafa",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 8,
                        flexWrap: "wrap",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{ fontWeight: 700, fontSize: 14, color: "#1a3c2a" }}
                      >
                        {s.loan_id || "—"}
                      </span>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        {typeBadge(s.settlement_type)}
                        {statusBadge(s.status)}
                      </div>
                    </div>

                    {/* Mart bank info */}
                    {s.settlement_type === "mart" && s.status === "processed" && (
                      <div
                        style={{
                          marginBottom: 10,
                          padding: "8px 10px",
                          background: "#f1f8e9",
                          borderRadius: 6,
                          border: "1px solid #aed581",
                          fontSize: 12,
                          color: "#33691e",
                        }}
                      >
                        <strong>Payment:</strong> CAL BANK &bull; MARTA ACCOUNT
                        No. 1400005312247 &bull; Tamale Branch
                        <br />
                        Send receipt to:{" "}
                        <strong>upnmgmart@gmail.com</strong>
                      </div>
                    )}

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px 8px",
                        marginBottom: 12,
                      }}
                    >
                      <div>
                        <div style={mobileLabelStyle}>Amount (GHS)</div>
                        <div style={mobileValueStyle}>
                          {s.amount != null
                            ? Number(s.amount).toLocaleString("en-GH", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : "—"}
                        </div>
                      </div>
                      <div>
                        <div style={mobileLabelStyle}>Issue Date</div>
                        <div style={mobileValueStyle}>
                          {s.issue_date
                            ? new Date(s.issue_date).toLocaleDateString("en-GB")
                            : "—"}
                        </div>
                      </div>
                      <div>
                        <div style={mobileLabelStyle}>Last Payment Date</div>
                        <div style={mobileValueStyle}>
                          {s.last_expected_payment_date
                            ? new Date(
                              s.last_expected_payment_date
                            ).toLocaleDateString("en-GB")
                            : "—"}
                        </div>
                      </div>
                    </div>

                    {s.status === "processed" ? (
                      <button
                        onClick={() => handleDownloadPDF(s._id, s.member_name)}
                        disabled={downloading === s._id}
                        style={{
                          width: "100%",
                          background: downloading === s._id ? "#aaa" : "#2d6a4f",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8,
                          padding: "10px",
                          fontSize: 14,
                          cursor: downloading === s._id ? "not-allowed" : "pointer",
                          fontWeight: 600,
                        }}
                      >
                        {downloading === s._id
                          ? "Downloading..."
                          : "Download PDF"}
                      </button>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          color: "#aaa",
                          fontSize: 13,
                          padding: "6px 0",
                        }}
                      >
                        Awaiting processing
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              /* ── Desktop: table ── */
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: 14,
                  }}
                >
                  <thead>
                    <tr style={{ background: "#f5f5f5" }}>
                      {[
                        "Type",
                        "Loan / Ref ID",
                        "Amount (GHS)",
                        "Issue Date",
                        "Last Payment Date",
                        "Status",
                        "Action",
                      ].map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "11px 12px",
                            textAlign: "left",
                            fontWeight: 700,
                            color: "#333",
                            borderBottom: "2px solid #e0e0e0",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {settlements.map((s, idx) => (
                      <tr
                        key={s._id}
                        style={{
                          background: idx % 2 === 0 ? "#fff" : "#fafafa",
                          borderBottom: "1px solid #f0f0f0",
                        }}
                      >
                        <td style={tdStyle}>{typeBadge(s.settlement_type)}</td>
                        <td style={tdStyle}>{s.loan_id || "—"}</td>
                        <td style={tdStyle}>
                          {s.amount != null
                            ? Number(s.amount).toLocaleString("en-GH", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : "—"}
                        </td>
                        <td style={tdStyle}>
                          {s.issue_date
                            ? new Date(s.issue_date).toLocaleDateString("en-GB")
                            : "—"}
                        </td>
                        <td style={tdStyle}>
                          {s.last_expected_payment_date
                            ? new Date(
                              s.last_expected_payment_date
                            ).toLocaleDateString("en-GB")
                            : "—"}
                        </td>
                        <td style={tdStyle}>{statusBadge(s.status)}</td>
                        <td style={tdStyle}>
                          {s.status === "processed" ? (
                            <button
                              onClick={() =>
                                handleDownloadPDF(s._id, s.member_name)
                              }
                              disabled={downloading === s._id}
                              style={{
                                background:
                                  downloading === s._id ? "#aaa" : "#2d6a4f",
                                color: "#fff",
                                border: "none",
                                borderRadius: 6,
                                padding: "7px 14px",
                                fontSize: 13,
                                cursor:
                                  downloading === s._id
                                    ? "not-allowed"
                                    : "pointer",
                                fontWeight: 600,
                              }}
                            >
                              {downloading === s._id
                                ? "Downloading..."
                                : "Download PDF"}
                            </button>
                          ) : (
                            <span style={{ color: "#aaa", fontSize: 13 }}>
                              Awaiting processing
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Mart payment info card */}
        {settlements.some((s) => s.settlement_type === "mart" && s.status === "processed") && (
          <div
            style={{
              marginTop: 20,
              background: "#fff",
              borderRadius: 10,
              boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
              border: "1px solid #aed581",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                background: "#33691e",
                padding: "12px 20px",
                color: "#fff",
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              UPNMG Mart — Payment Instructions
            </div>
            <div style={{ padding: "16px 20px", fontSize: 13, color: "#333", lineHeight: 1.7 }}>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Bank:</strong> CAL BANK
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Account Name:</strong> Union of Prof. Nurses n Midwives
                Gh. — MART A ACCOUNT
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Account No.:</strong> 1400005312247
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Branch:</strong> Tamale
              </p>
              <p style={{ margin: "0 0 6px" }}>
                <strong>Email receipt to:</strong>{" "}
                <a
                  href="mailto:upnmgmart@gmail.com"
                  style={{ color: "#33691e" }}
                >
                  upnmgmart@gmail.com
                </a>
              </p>
              <p style={{ margin: "10px 0 0", fontSize: 12, color: "#666" }}>
                Your Mart loan account will be closed ONLY when payment has been
                confirmed in the bank account and payment receipt received via
                email.
              </p>
            </div>
          </div>
        )}
      </div>
    </RenderHome>
  );
}

const tdStyle = {
  padding: "11px 12px",
  color: "#444",
  verticalAlign: "middle",
};

const mobileLabelStyle = {
  fontSize: 11,
  color: "#888",
  textTransform: "uppercase",
  fontWeight: 500,
  marginBottom: 2,
};

const mobileValueStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: "#1a3c2a",
};

export default MySettlementQuotation;
